import React, { useEffect, useState } from "react";
import { ResumeCard } from "./components/ResumeCard";
import UsersReport from "./components/UsersReport";
// import RealEstateAgencyReport from "./components/RealEstateAgencyReport";
// import AdsReport from "./components/AdsReport";
// import AdsStatusReport from "./components/AdsStatusReport";
// import ProspectsAndConversionsReport from "./components/ProspectsAndConversionsReport";
// import { DateHelper } from "@/app/core/util/helpers/DateHelper";
import { AccountController } from "@/app/core/base/controllers/AccountController";
// import { RealEstateAgencyController } from "@/app/core/base/controllers/RealEstateAgencyController";
// import { PropertiesController } from "@/app/core/base/controllers/PropertiesController";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import ComplainReport from "./components/ComplainReport";

export default function AdministratorPanel() {
  const [resume, setResume] = useState({
    ads: 0,
    users: 0,
    realtor: 0,
    realEstateAgency: 0,
  });

  useEffect(() => {
    loadCounter();
  }, []);

  async function loadCounter() {
    /* Usuários, Corretores, Imobiliárias, Anúncios */
    const results = await Promise.all([
      AccountController.GetTotalCountByLevel(UserHelper.UserLevel.User),
      AccountController.GetTotalCountByLevel(UserHelper.UserLevel.Commercial),
      CompanyController.GetTotalCount(),
      ComplainController.GetTotalCount(),
    ]);
    setResume({
      users: results[0],
      commercial: results[1],
      companies: results[2],
      complains: results[3],
    });

    console.log("resultados", results[0],
        results[1])
  }

  return (
    <div className="content">

        <div className="row">
        <div className="col-12">
            <div className="title">
            <h2 className="content-heading">
                <i className="fa fa-angle-right text-muted mr-1"></i> Contadores
                Gerais
            </h2>
            </div>
        </div>
        <div className="col-md-3">
            <ResumeCard title="Usuários" current={resume && resume.users} />
        </div>
        <div className="col-md-3">
            <ResumeCard title="Comercial" current={resume && resume.commercial} />
        </div>
        <div className="col-md-3">
            <ResumeCard
            title="Empresas"
            current={resume && resume.companies}
            />
        </div>
        <div className="col-md-3">
            <ResumeCard title="Reclamações" current={resume && resume.complains} />
        </div>

        <div className="col-12">
            <div className="title">
            <h2 className="content-heading">
                <i className="fa fa-angle-right text-muted mr-1"></i> Dashboard
            </h2>
            </div>
        </div>
        <div className="col-12">
            <UsersReport />
            {/* <ProspectsAndConversionsReport />
            <RealEstateAgencyReport />
            <AdsReport />
             */}
             <ComplainReport />
        </div>
        </div>
    </div>
  );
}
